<div class="card card-custom">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">View Target Property Template "{{tpTemplate.name}}" (READ ONLY)</h3>
        </div>
        <div class="card-toolbar">
			<button mat-button mat-raised-button style="background-color: orange; color: white"
				color="warn" aria-label="Close" (click)="onNoClick()">
				<span aria-hidden="true">&times;</span>
			</button>
        </div>
    </div>
    <div class="card-body">
        <mat-dialog-content>
            <kt-tp-template-body
            [tpTemplateModel]="tpTemplate"
            [readonly]="true"></kt-tp-template-body>
        </mat-dialog-content>
    </div>
</div>